module.exports = __webpack_public_path__ + "96574ccd1ed22ce6497f91fdcb14939f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/section6/imgs/5.jpg
// module id = 398
// module chunks = 0